module.exports = __webpack_public_path__ + "img/cm.7ece32b5.svg";